import { toCamelCase } from '../../../common/config/utils';

export const generateDynamicRoutesTranslations = (lang: string) => {
  const { routes } = (window as any).config.uiSettings;
  return Object.fromEntries(
    Object.keys(routes).map((key: string) => [toCamelCase(key), (routes[key].translations?.[lang].slug || routes[key].slug || key)])
  );
};

export const enum LANGUAGES {
  en = 'en',
  es = 'es',
  pt = 'pt'
}
